/**
 * Gospel fragments for the translation scramble animation.
 * Latin, Spanish, and English — all from the Gospels and Vulgate.
 */

export const GOSPEL_FRAGMENTS = [
  // Latin
  "In principio erat Verbum",
  "Et Verbum caro factum est",
  "Ego sum via et veritas et vita",
  "Fiat lux",
  "Pater noster qui es in caelis",
  "Beati pauperes spiritu",
  "Beati mites",
  "Beati qui lugent",
  "Beati esurientes",
  "Beati misericordes",
  "Beati mundo corde",
  "Beati pacifici",
  "Gloria in excelsis Deo",
  "Venite ad me omnes",
  "Lux in tenebris lucet",
  "Panem nostrum cotidianum",
  "Sicut in caelo et in terra",
  "Miserere mei Deus",
  "Credo in unum Deum",
  "Spiritus ubi vult spirat",
  "Noli timere",
  "Pax vobis",
  "Surrexit Dominus vere",
  "Caritas numquam excidit",
  "Omnia possibilia credenti",
  "Sinite parvulos venire ad me",
  "Amen dico vobis",
  "Regnum Dei intra vos est",
  "Qui habet aures audiat",
  "Lumen gentium",
  "Agnus Dei qui tollis peccata mundi",
  "Verbum caro factum est et habitavit in nobis",
  "Gratia plena Dominus tecum",
  "Ecce ancilla Domini",
  "Fiat mihi secundum verbum tuum",
  "Magnificat anima mea Dominum",
  "Qui potest capere capiat",
  "Semen cecidit in terram bonam",
  // Spanish
  "El que tiene oídos que oiga",
  "El Reino de Dios está entre vosotros",
  "Yo soy el camino la verdad y la vida",
  "El que cree en mí tiene vida eterna",
  "No temas sólo cree",
  "Venid a mí todos los que estáis trabajados",
  "Bienaventurados los pobres de espíritu",
  "Bienaventurados los mansos",
  "Bienaventurados los que lloran",
  "Bienaventurados los que tienen hambre",
  "Bienaventurados los misericordiosos",
  "Bienaventurados los limpios de corazón",
  "Bienaventurados los pacificadores",
  "Gloria a Dios en las alturas",
  "La luz brilla en las tinieblas",
  "Dios es amor",
  "Todo lo puedo en Cristo que me fortalece",
  "El amor nunca deja de ser",
  "La paz os dejo mi paz os doy",
  "Soy la luz del mundo",
  "Soy la puerta de las ovejas",
  "Yo soy la resurrección y la vida",
  "Pedid y se os dará",
  "Perdonad si queréis ser perdonados",
  "El que sin pecado esté tire la primera piedra",
  "Haced esto en memoria mía",
  "Este es mi cuerpo",
  "Este es mi sangre",
  "No solo de pan vive el hombre",
  "Buscad primero el Reino de Dios",
  // English
  "In the beginning was the Word",
  "The Word became flesh",
  "I am the way the truth and the life",
  "Let there be light",
  "Our Father who art in heaven",
  "Blessed are the poor in spirit",
  "Blessed are the meek",
  "Blessed are they that mourn",
  "Blessed are they which do hunger",
  "Blessed are the merciful",
  "Blessed are the pure in heart",
  "Blessed are the peacemakers",
  "Glory to God in the highest",
  "Come unto me all ye that labour",
  "The light shineth in darkness",
  "Give us this day our daily bread",
  "On earth as it is in heaven",
  "Have mercy on me O God",
  "God so loved the world",
  "The wind bloweth where it listeth",
  "Fear not only believe",
  "Peace be unto you",
  "The Lord is risen indeed",
  "Charity never faileth",
  "All things are possible to him that believeth",
  "Suffer the little children to come unto me",
  "Verily I say unto you",
  "The Kingdom of God is within you",
  "He that hath ears to hear",
  "A light to lighten the Gentiles",
  "Lamb of God that takest away the sins",
  "And the Word was made flesh and dwelt among us",
  "Hail full of grace the Lord is with thee",
  "Behold the handmaid of the Lord",
  "Be it unto me according to thy word",
  "My soul doth magnify the Lord",
  "He that is able to receive it let him receive it",
  "The seed fell into good ground",
];

export default GOSPEL_FRAGMENTS;
